import BaseSvg, { Props } from '../BaseSvg'

const Favourites: React.FC<Props> = (props) => (
  <BaseSvg height={22} viewBox="0 -1 21 22" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.99999 1.83854C11.9262 0.234375 13.9314 -0.166666 16.0156 0.635416C18.6724 1.65786 19.625 4.18653 19.625 6.65103C19.625 10.1949 16.4166 14.2053 9.99999 18.6823C3.58333 14.2053 0.375 10.1949 0.375 6.65103C0.375 4.37928 1.29611 1.69567 3.98437 0.635416C6.01804 -0.166666 8.02324 0.234375 9.99999 1.83854Z" />
  </BaseSvg>
)

export default Favourites
